import apiCrud from '../../abstract/api-crud';

const baseUri = `${ import.meta.env.VITE_SITE_URL }/crms/agreement-files`;
export const modelName = 'agreementfile';

export default {
  ...apiCrud({ baseUri, modelName }),
  storeSignerToken: async ({ id }) => await axios.post(`${ baseUri }/${ id }/signer-tokens`),
  storeMail: async ({ id }, data) => await axios.post(`${ baseUri }/${ id }/mails`, data),
  showCrmMail: async ({ id }) => await axios.get(`${ baseUri }/${ id }/crm-mail`),
  showContent: async ({ id }) => await axios.get(`${ baseUri }/${ id }/content`),
};
